import { useEffect, useState } from 'react';
import useClient from 'api/client';
import { useAlert } from 'components/message/AlertContext';
import { useParams } from 'react-router-dom';
import { FormatDate } from 'components/dates/FormatDate';
import { OrganizationListItem } from 'types/Organization';
import queryOrganization from 'api/Organization/queryOrganization';
import { ItemsDetails } from 'components/details/EditorDetails';

export default function useOrganization() {
    const client = useClient();
    const { openAlert } = useAlert();
    const params = useParams<{ uri: string }>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [disableDelete, setDisableDelete] = useState(false);

    const [organization, setOrganization] = useState<OrganizationListItem>({
        organizationUri: '',
        created: '',
        owner: '',
        SamlGroupName: '',
        label: '',
        description: '',
        stats: { environments: 0 },
    });
    const [items, setItems] = useState<ItemsDetails>({
        created: '',
        label: '',
        description: '',
        data: [],
    });

    const [userIsAdmin, setUserIsAdmin] = useState(false);
    const fetchData = async () => {
        try {
            if (params.uri) {
                setLoading(true);
                const response = await client?.query(
                    queryOrganization(params.uri),
                );
                if (!response.errors) {
                    setOrganization({
                        ...response.data.getOrganization,
                        created: FormatDate(
                            response.data.getOrganization.created,
                        ),
                    });
                    setItems({
                        label: response.data.getOrganization.label,
                        description: response.data.getOrganization.description,
                        data: [
                            {
                                label: 'Created by',
                                value: response.data.getOrganization.owner,
                            },
                            {
                                label: 'Admin',
                                value: response.data.getOrganization
                                    .SamlGroupName,
                            },
                        ],
                    });
                    setDisableDelete(
                        response.data.getOrganization.environments.count > 0,
                    );
                    setUserIsAdmin(
                        ['Admin', 'Owner'].includes(
                            response.data.getOrganization
                                .userRoleInOrganization,
                        ),
                    );
                } else {
                    setError(true);
                    openAlert({
                        message:
                            'Something went wrong... Could not retrieve organization',
                        severity: 'alert',
                    });
                }
            }
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (client) {
            fetchData();
        }
    }, [client, params.uri]);

    return {
        organization,
        disableDelete,
        userIsAdmin,
        items,
        error,
        loading,
        fetchData,
    };
}
